"use client";

import { DemoOrganizationChrome } from "@/components/common/demo";
import { LanguageToggle, ThemeToggle } from "@/components/common/toggles";
import NextLink from "next/link";
import { Icon } from "@iconify/react";
import { useTranslate } from "@tolgee/react";

/**
 * Full-viewport admin chrome (dashboard link + theme), shared by organization and project admin.
 */
export function AdminShellLayout({ children }: Readonly<{ children: React.ReactNode }>) {
  const { t } = useTranslate();
  return (
    <DemoOrganizationChrome>
      <div className="flex h-full min-h-0 flex-col bg-white dark:bg-dark-base">
        <header className="flex h-14 shrink-0 items-center justify-between gap-4 border-b border-zinc-200 px-4 dark:border-zinc-700">
          <NextLink
            href="/dashboard"
            className="inline-flex items-center gap-2 text-sm font-medium text-zinc-600 hover:text-zinc-950 dark:text-zinc-400 dark:hover:text-white"
          >
            <Icon icon="ph:arrow-left" className="size-4" />
            {t("dashboard.dashboard")}
          </NextLink>
          <ThemeToggle />
          <LanguageToggle />
        </header>
        <div className="flex min-h-0 flex-1 flex-col">{children}</div>
      </div>
    </DemoOrganizationChrome>
  );
}
